import request from "root/js/request";

export const getExpensesTemplateCrossMPExport = async ({ cabinet_id, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/group/export/",
    method: "get",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};